import PropTypes from 'prop-types';
import React from 'react';
import CategoryGridResultsCount from '../../CategoryGridResultsCount/CategoryGridResultsCount';
import DesktopCategoryGridHeader from './DesktopCategoryGridHeader';
import MobileCategoryGridHeader from './MobileCategoryGridHeader';

function CategoryGridHeader({
  brand,
  categoryId,
  categoryName,
  categoryTitle = '',
  categoryUrl = '',
  facet = [],
  facetData = [],
  filter = '',
  hasSelectedCategoryFilters = false,
  navParentCategoryId,
  onCheckBoxChange = () => { },
  onClearAllBtnClick = () => { },
  onFacetTagClick = () => { },
  onSortChange = () => { },
  resultsCount,
  selectedSort = '',
  sortData = {
    sortOptions: [],
  },
  storeDetails = {
    storeName: '',
    storeId: '',
  },
}) {
  const categoryResultsCount = hasSelectedCategoryFilters ? (
    <CategoryGridResultsCount
      count={resultsCount}
      hasMobileGridHeader
      hasSelectedFilters={hasSelectedCategoryFilters}
      onClearAllBtnClick={onClearAllBtnClick}
    />
  ) : null;

  return (
    <>
      <MobileCategoryGridHeader
        brand={brand}
        categoryId={categoryId}
        categoryName={categoryName}
        categoryResultsCount={categoryResultsCount}
        categoryTitle={categoryTitle}
        categoryUrl={categoryUrl}
        facet={facet}
        facetData={facetData}
        filter={filter}
        navParentCategoryId={navParentCategoryId}
        onCheckBoxChange={onCheckBoxChange}
        onClearAllBtnClick={onClearAllBtnClick}
        onFacetTagClick={onFacetTagClick}
        onSortChange={onSortChange}
        resultsCount={resultsCount}
        selectedSort={selectedSort}
        sortData={sortData}
        storeDetails={storeDetails}
      />
      <DesktopCategoryGridHeader
        categoryName={categoryName}
        categoryResultsCount={categoryResultsCount}
        categoryTitle={categoryTitle}
        facet={facet}
        onFacetTagClick={onFacetTagClick}
        onSortChange={onSortChange}
        selectedSort={selectedSort}
        sortData={sortData}
      />
    </>
  );
}

CategoryGridHeader.propTypes = {
  brand: PropTypes.string.isRequired,
  categoryId: PropTypes.string.isRequired,
  categoryName: PropTypes.string.isRequired,
  categoryTitle: PropTypes.string,
  categoryUrl: PropTypes.string,
  resultsCount: PropTypes.number.isRequired,
  facet: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.string]),
  filter: PropTypes.string,
  hasSelectedCategoryFilters: PropTypes.bool.isRequired,
  navParentCategoryId: PropTypes.string.isRequired,
  onFacetTagClick: PropTypes.func,
  onSortChange: PropTypes.func,
  selectedSort: PropTypes.string,
  sortData: PropTypes.shape({
    sortOptions: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
        value: PropTypes.string,
      }),
    ),
  }),
  facetData: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.any)),
  onClearAllBtnClick: PropTypes.func,
  onCheckBoxChange: PropTypes.func,
  storeDetails: PropTypes.shape({
    storeName: PropTypes.string,
    storeId: PropTypes.string,
  }),
};

export default CategoryGridHeader;
